<template>
    <div style="height: 100vh">
        <nav class="navbar navbar-expand navbar-dark bg-primary">
            <a class="sidebar-toggle text-light mr-3" @click="toggleMenu"><i class="fa fa-bars"></i></a>
            <a class="navbar-brand" href="#" @click.prevent="navigate('/')" ><i class="fa fa-desktop"></i> Colors Computer</a>

            <div class="navbar-collapse collapse">
                <ul class="navbar-nav ml-auto">
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" data-toggle="dropdown">
                            <i class="fa fa-user"></i> {{ user.username}}
                        </a>
                        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink">
                            <a v-if="isAdmin" class="dropdown-item" href="#" @click.prevent="navigate('/admin')">Admin beállítások</a>
                            <a class="dropdown-item" href="#" @click.prevent="logout">Kijelentkezés</a>
                        </div>
                    </li>
                </ul>
            </div>
        </nav>
        <div class="container-fluid h-100">
            <div class="row h-100">
                <div :class="sidebarClasses">
                    <ul class="list-unstyled">
                        <li><a @click.prevent="navigate('/ugyfelek')" href="#"><i class="fa fa-fw fa-users"></i> Ügyfelek</a></li>
                        <li><a @click.prevent="navigate('/uj-ugyfel')" href="#"><i class="fa fa-fw fa-user-plus"></i> Új ügyfél</a></li>
                        <li><a @click.prevent="navigate('/szervizmunkak')" href="#"><i class="fa fa-fw fa-cogs"></i> Szervízmunkák</a></li>
                        <li><a @click.prevent="navigate('/uj-szervizmunka')" href="#"><i class="fa fa-fw fa-wrench"></i> Új szervízmunka</a></li>
                        <li v-if="isAdmin"><a @click.prevent="navigate('/admin')" href="#"><i class="fa fa-fw fa-lock text-danger"></i> Admin beállítások</a></li>
                    </ul>
                </div>
                <div class="col">
                    <router-view/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        name: 'Frame',
        data(){
            return {
                showMenu: true
            }
        },
        computed: {
            user(){
                return this.$store.getters['LoginModul/getUser'];
            },
            isLogged(){
                return this.$store.getters['LoginModul/isLogged'];
            },
            sidebarClasses(){
                return {
                    'sidebar': true,
                    'bg-dark': true,
                    'visible': this.showMenu
                }
            },
            isAdmin(){
                return this.$store.getters['LoginModul/isAdmin'];
            }
        },
        watch: {
            isLogged(){
                if(this.isLogged === false){
                    this.$router.push('/login');
                }
            }
        },
        methods: {
            toggleMenu(){
                this.showMenu = !this.showMenu;
            },
            logout(){
                this.$store.dispatch('LoginModul/logout');
            },
            navigate(destination){
                this.$router.push(destination);
            }
        }
    }
</script>

<style scoped>
    .sidebar{
        width:250px;
        min-width:250px;
        margin-left:0;
        background: rgba(255, 255, 255, .75);
        transition: margin-left 0.5s;
    }
    .sidebar.visible{
        margin-left:-250px;
    }
    .sidebar-toggle{
        cursor: pointer;
    }
    .sidebar ul li a {
        display: block;
        padding: .75rem 1rem;
        color: rgba(255, 255, 255, .75);
        text-decoration: none;
    }
    .sidebar ul li a:hover, .sidebar ul .active a {
        color: rgba(255, 255, 255, 1);
        background: rgba(0, 0, 0, .25);
    }
    .sidebar ul ul a {
        padding-left: 2.5rem;
        background: rgba(0, 0, 0, .25);
    }


</style>



// WEBPACK FOOTER //
// src/components/Frame.vue